document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-opti-faq]').forEach((wrap) => {
    wrap.querySelectorAll('.opti-faq-question').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.opti-faq-item');
        const expanded = item.classList.contains('is-open');
        if (wrap.dataset.singleOpen === 'true') {
          wrap.querySelectorAll('.opti-faq-item').forEach((el) => el.classList.remove('is-open'));
        }
        if (!expanded) item.classList.add('is-open');
      });
    });
  });
});
